import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import withAuth from '../Utils/withAuth';
import {
  Stack,
  useToast,
} from '@chakra-ui/react';
import ContentHeader from '../Components/General/ContentHeader';
import Footer from '../Components/General/Footer';
import BlockchainViewerModal from '../Components/Cert/BlockchainViewerModal.js';
import PasswordModal from '../Components/Cert/PasswordModal.js';
import SendEmailModal from '../Components/Cert/SendEmailModal.js';
import ConfirmDeleteModal from '../Components/Cert/ConfirmDeleteModal.js';
import CompanyFormModal from '../Components/Cert/CompanyFormModal.js';
import EmailManagerModal from '../Components/Cert/EmailManagerModal.js';
import CompanyManagerModal from '../Components/Cert/CompanyManagerModal.js';
import TabsContainer from '../Components/Cert/TabsContainer.js';
import { getShareLink, cancelShareLink } from '../Utils/api';
import dayjs from 'dayjs';
// CSS样式导入
import '../Styles/theme/PasswordModel.css';
import '../Styles/theme/blockchain_window.css';
import { passwordUpdate } from '../Utils/api';
//SendMail
import { sendMail } from '../Utils/api';
import { getTransactionInfo } from '../Utils/api';

import {
  getEmailList,
  getEmailDetail,
  createEmail,
  updateEmail,
  deleteEmail
} from '../Utils/api';

import {
  getCompanyList,
  getCompanyDetail,
  createCompany,
  updateCompany,
  deleteCompany
} from '../Utils/api';

// Import our helper functions
import {
  isEmailInFrequentList,
  addRecipientToFrequent
} from '../Components/Cert/FrequentEmailHelper';

function Cert(props) {
  // 狀態管理
  const [showModel, setShowModel] = useState(false);
  const [password, setPassword] = useState('');
  const [showModel2, setShowModel2] = useState(false);
  const [emails, setEmails] = useState([
    { email: '', name: '', company: '', includePassword: true }
  ]);
  const [emailError, setEmailError] = useState('');
  const [showModel3, setShowModel3] = useState(false);
  const [tx_place_no, setTxPlaceNo] = useState('');
  const [tx_company_no, setTxCompanyNo] = useState('');
  const [tx_paction_no, setTxPactionNo] = useState('');
  const [tx_TransactionHash, setTxHash] = useState('');
  const [tx_block_hash, setTxBlockHash] = useState('');
  const [tx_block_number, setTxBlockNumber] = useState('');
  const [tx_raw_data, setTxRawData] = useState('');

  // 常用信箱相關狀態
  const [showFrequentEmails, setShowFrequentEmails] = useState(false);
  const [frequentEmails, setFrequentEmails] = useState([]);
  const [searchFrequentEmail, setSearchFrequentEmail] = useState('');
  const [newEmailInfo, setNewEmailInfo] = useState({
    email: '',
    name: '',
    company: '',
    recipient_company_no: '',
    recipient_place_no: '',
    receiver_company_id: ''
  });
  const [serverFrequentEmails, setServerFrequentEmails] = useState([]);
  const [isLoadingEmails, setIsLoadingEmails] = useState(false);
  const [showConfirmDelete, setShowConfirmDelete] = useState(null);
  const [isEditingEmail, setIsEditingEmail] = useState(false);
  const [selectedEmail, setSelectedEmail] = useState(null);

  // 公司管理相關狀態
  const [showCompanyList, setShowCompanyList] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [searchCompany, setSearchCompany] = useState('');
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [newCompanyInfo, setNewCompanyInfo] = useState({
    company_name: '',
    company_tel: '',
    company_address: ''
  });
  const [isEditingCompany, setIsEditingCompany] = useState(false);
  const [showCompanyForm, setShowCompanyForm] = useState(false);
  const [isLoadingCompany, setIsLoadingCompany] = useState(false);
  const [showDeleteCompanyConfirm, setShowDeleteCompanyConfirm] = useState(null);

  const { id } = useParams();
  const [url, setUrl] = useState();
  const [tabIndex, setTabIndex] = React.useState(0);
  const { certName, people_ID, place_ID, area, tx } =
    (props.location && props.location.state) || {};
  const [shareInfo, setShareInfo] = React.useState({
    shared: false,
    shareDate: '',
    shareLink: '',
  });
  const toastIdRef = React.useRef();
  const toast = useToast();

  React.useEffect(() => {
    const rawBase = (process.env.REACT_APP_END_POINT || '/backend').replace(/\/+$/, '');
    const baseURL = rawBase.endsWith('/backend') ? rawBase : `${rawBase}/backend`;
    const url = `${baseURL}/paction/pdf?paction_no=${encodeURIComponent(certName)}`;
    setUrl(url);

    const savedEmails = localStorage.getItem('frequentEmails');
    if (savedEmails) {
      try {
        setFrequentEmails(JSON.parse(savedEmails));
      } catch (error) {
        setFrequentEmails([]);
      }
    }

    if (people_ID && place_ID) {
      fetchServerEmails();
      fetchCompanyList(false);
    }
  }, [certName, people_ID, place_ID]);

  React.useEffect(() => {
    if (companies.length > 0 && serverFrequentEmails.length > 0) {
      fetchServerEmails();
    }
  }, [companies]);


  const fetchServerEmails = async () => {
    setIsLoadingEmails(true);
    try {
      const response = await getEmailList(place_ID, people_ID);
      if (response && Array.isArray(response)) {
        const mappedEmails = response.map(email => {
          const matchingCompany = companies.find(c => c.id === Number(email.receiver_company_id));
          const companyName = matchingCompany ? matchingCompany.company_name : email.company_name;

          return {
            id: email.id,
            email: email.receiver_email || '',
            name: email.receiver_name || '',
            company: companyName,
            receiver_company_id: email.receiver_company_id,
            recipient_company_no: matchingCompany ? matchingCompany.recipient_company_no : '',
            recipient_place_no: matchingCompany ? matchingCompany.recipient_place_no : '',
            isServer: true
          };
        });

        setServerFrequentEmails(mappedEmails);
      }
    } catch (error) {
      toast({
        title: "獲取常用信箱失敗",
        description: "請稍後再試",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsLoadingEmails(false);
    }
  };
  const fetchCompanyList = async (switchToCompanyView = true) => {
    setIsLoadingCompany(true);
    if (switchToCompanyView) {
      setShowCompanyList(true);
      setShowFrequentEmails(false);
    }

    try {
      const response = await getCompanyList(place_ID, people_ID);
      if (response && Array.isArray(response)) {
        const sortedCompanies = response.sort((a, b) => a.id - b.id);
        setCompanies(sortedCompanies);
        await fetchServerEmails();
      }
    } catch (error) {
      toast({
        title: "獲取公司列表失敗",
        description: "請稍後再試",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsLoadingCompany(false);
    }
  };

  const handleClosePasswordModal = () => {
    setShowModel(false);
    setPassword('');
  };

  const handleLinkClick = (transaction_hash) => {
    getTransactionInfo(transaction_hash)
      .then((response_data) => {
        setTxPlaceNo(response_data.place_no);
        setTxCompanyNo(response_data.company_no);
        setTxPactionNo(response_data.paction_no);
        setTxBlockHash(response_data.block_hash);
        setTxBlockNumber(response_data.block_number);
        setTxRawData(response_data.raw_data);
        setTxHash(transaction_hash);
      });
  };

  const handleEmailChange = (index, field, value) => {
    const updatedEmails = [...emails];
    updatedEmails[index][field] = value;
    setEmails(updatedEmails);
  };

  const addEmailField = () => {
    setEmails([...emails, { email: '', name: '', company: '', includePassword: true }]);
  };

  const removeEmailField = (index) => {
    if (emails.length > 1) {
      const updatedEmails = emails.filter((_, i) => i !== index);
      setEmails(updatedEmails);
    }
  };

  const filteredFrequentEmails = React.useMemo(() => {
    let allEmails = [
      ...frequentEmails,
      ...serverFrequentEmails.map(email => ({
        id: email.id,
        email: email.email || '',
        name: email.name || '',
        company: email.company || '',
        receiver_company_id: email.receiver_company_id,
        isServer: true
      }))
    ];

    allEmails = allEmails.map(email => {
      if (email.receiver_company_id) {
        const matchingCompany = companies.find(c => c.id === Number(email.receiver_company_id));
        if (matchingCompany) {
          return {
            ...email,
            company: matchingCompany.company_name,
            recipient_company_no: matchingCompany.recipient_company_no || '',
            recipient_place_no: matchingCompany.recipient_place_no || '',
          };
        }
      }
      return email;
    });

    const searchTerm = searchFrequentEmail.toLowerCase();
    return allEmails.filter(email => {
      return (
        (email.email && email.email.toLowerCase().includes(searchTerm)) ||
        (email.name && email.name.toLowerCase().includes(searchTerm)) ||
        (email.company && email.company.toLowerCase().includes(searchTerm))
      );
    });
  }, [frequentEmails, serverFrequentEmails, searchFrequentEmail, companies]); // 注意這裡添加了 companies 作為依賴

  const handleAddFrequentEmail = async () => {
    if (!newEmailInfo.email || !newEmailInfo.name || !newEmailInfo.company) {
      toast({
        title: "訊息不完整",
        description: "請填寫完整收件者訊息",
        status: "warning",
        duration: 2000,
        isClosable: true,
      });
      return;
    }

    const emailRegex = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/;
    if (!emailRegex.test(newEmailInfo.email)) {
      toast({
        title: "郵箱格式不正確",
        description: "請輸入有效的電子郵箱地址",
        status: "error",
        duration: 2000,
        isClosable: true,
      });
      return;
    }

    const exists = filteredFrequentEmails.some(item => item.email === newEmailInfo.email);
    if (exists) {
      toast({
        title: "郵箱已存在",
        description: "此郵箱已在常用信箱列表中",
        status: "info",
        duration: 2000,
        isClosable: true,
      });
      return;
    }

    if (people_ID && place_ID) {
      setIsLoadingEmails(true);
      try {
        // 準備查詢參數
        const queryParams = {
          place_no: place_ID,
          company_no: people_ID
        };

        const finalCompanyId = Number(newEmailInfo.receiver_company_id) ||
          (companies && companies.length > 0 ? Number(companies[0].id) : 1);

        // 如果填寫了運作人或場所管編，更新對應公司的管編資料
        if (finalCompanyId && (newEmailInfo.recipient_company_no || newEmailInfo.recipient_place_no)) {
          const selectedCompany = companies.find(c => c.id === finalCompanyId);
          if (selectedCompany) {
            const companyBody = {
              company_name: selectedCompany.company_name,
              company_tel: selectedCompany.company_tel || '',
              company_address: selectedCompany.company_address || '',
              recipient_company_no: newEmailInfo.recipient_company_no || '',
              recipient_place_no: newEmailInfo.recipient_place_no || ''
            };
            await updateCompany(selectedCompany.id, companyBody, queryParams);
          }
        }

        const bodyData = {
          receiver_email: newEmailInfo.email,
          receiver_name: newEmailInfo.name,
          company_name: newEmailInfo.company,
          receiver_company_id: finalCompanyId
        };

        await createEmail(bodyData, queryParams);

        await fetchServerEmails();
        await fetchCompanyList(false);

        setNewEmailInfo({
          email: '',
          name: '',
          company: '',
          recipient_company_no: '',
          recipient_place_no: '',
          receiver_company_id: ''
        });

        toast({
          title: "新增成功",
          description: "已將收件者添加至常用信箱",
          status: "success",
          duration: 2000,
          isClosable: true,
        });
        return;
      } catch (error) {
        toast({
          title: "保存至服務器失敗",
          description: "將只保存至本地",
          status: "warning",
          duration: 3000,
          isClosable: true,
        });
      } finally {
        setIsLoadingEmails(false);
      }
    }

    const updatedEmails = [...frequentEmails, {
      ...newEmailInfo,
      id: `local-${Date.now()}`,
      includePassword: true
    }];

    setFrequentEmails(updatedEmails);
    localStorage.setItem('frequentEmails', JSON.stringify(updatedEmails));

    setNewEmailInfo({ email: '', name: '', company: '' });

    toast({
      title: "新增成功",
      description: "已將收件者添加至本地常用信箱",
      status: "success",
      duration: 2000,
      isClosable: true,
    });
  };

  const handleDeleteFrequentEmail = async (id, e) => {
    e.stopPropagation();
    setShowConfirmDelete(id);
  };

  const confirmDelete = async (emailId) => {
    setIsLoadingEmails(true);

    const serverEmail = serverFrequentEmails.find(email => email.id === emailId);

    if (serverEmail) {
      try {
        await deleteEmail(emailId);
        await fetchServerEmails();
        toast({
          title: "刪除成功",
          description: "已從常用信箱移除該收件者",
          status: "success",
          duration: 2000,
          isClosable: true,
        });
      } catch (error) {
        toast({
          title: "刪除失敗",
          description: "無法移除該收件者，請稍後再試",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } else {
      const updatedEmails = frequentEmails.filter(email => email.id !== emailId && email.email !== emailId);
      setFrequentEmails(updatedEmails);
      localStorage.setItem('frequentEmails', JSON.stringify(updatedEmails));

      toast({
        title: "刪除成功",
        description: "已從本地常用信箱移除該收件者",
        status: "success",
        duration: 2000,
        isClosable: true,
      });
    }

    setIsLoadingEmails(false);
    setShowConfirmDelete(null);
  };

  const handleSelectFrequentEmail = (email) => {
    const updatedEmails = [...emails];
    const lastEmail = updatedEmails[updatedEmails.length - 1];

    if (!lastEmail.email) {
      updatedEmails[updatedEmails.length - 1] = {
        email: email.email,
        name: email.name || '',
        company: email.company || '',
        recipient_company_no: email.recipient_company_no || '',
        recipient_place_no: email.recipient_place_no || '',
        includePassword: true
      };
    } else {
      updatedEmails.push({
        email: email.email,
        name: email.name || '',
        company: email.company || '',
        recipient_company_no: email.recipient_company_no || '',
        recipient_place_no: email.recipient_place_no || '',
        includePassword: true
      });
    }

    setEmails(updatedEmails);
    setShowFrequentEmails(false);

    toast({
      title: "已選擇收件人",
      description: "您可以繼續編輯或直接寄送",
      status: "info",
      duration: 2000,
      isClosable: true,
    });
  };
  const cancelDelete = () => {
    setShowConfirmDelete(null);
  };

  const handleNewEmailInfoChange = (field, value) => {
    setNewEmailInfo(prev => ({
      ...prev,
      [field]: value
    }));
  };
  const handleEditEmail = async (emailId, e) => {
    e.stopPropagation();
    setIsLoadingEmails(true);

    try {
      const emailDetail = await getEmailDetail(emailId);
      const matchingCompany = companies.find(c => c.id === Number(emailDetail.receiver_company_id));
      const companyName = matchingCompany ? matchingCompany.company_name : emailDetail.company_name;

      const mappedDetail = {
        id: emailDetail.id,
        email: emailDetail.receiver_email || '',
        name: emailDetail.receiver_name || '',
        company: companyName,
        receiver_company_id: emailDetail.receiver_company_id
      };
      setSelectedEmail(mappedDetail);
      setNewEmailInfo({
        email: mappedDetail.email,
        name: mappedDetail.name,
        company: companyName,
        receiver_company_id: emailDetail.receiver_company_id,
        recipient_company_no: matchingCompany ? matchingCompany.recipient_company_no || '' : '',
        recipient_place_no: matchingCompany ? matchingCompany.recipient_place_no || '' : ''
      });
      setIsEditingEmail(true);
    } catch (error) {
      toast({
        title: "獲取郵件詳情失敗",
        description: "請稍後再試",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsLoadingEmails(false);
    }
  };

  const handleSaveEmail = async () => {
    if (!newEmailInfo.email || !newEmailInfo.name || !newEmailInfo.company) {
      toast({
        title: "訊息不完整",
        description: "請填寫完整收件者訊息",
        status: "warning",
        duration: 2000,
        isClosable: true,
      });
      return;
    }

    const emailRegex = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/;
    if (!emailRegex.test(newEmailInfo.email)) {
      toast({
        title: "郵箱格式不正確",
        description: "請輸入有效的電子郵箱地址",
        status: "error",
        duration: 2000,
        isClosable: true,
      });
      return;
    }

    if (isEditingEmail && selectedEmail) {
      setIsLoadingEmails(true);
      try {
        const queryParams = {
          place_no: place_ID,
          company_no: people_ID
        };

        const finalCompanyId = Number(newEmailInfo.receiver_company_id) || Number(selectedEmail.receiver_company_id);

        // 如果填寫了運作人或場所管編，更新對應公司的管編資料
        if (finalCompanyId && (newEmailInfo.recipient_company_no || newEmailInfo.recipient_place_no)) {
          const selectedCompany = companies.find(c => c.id === finalCompanyId);
          if (selectedCompany) {
            const companyBody = {
              company_name: selectedCompany.company_name,
              company_tel: selectedCompany.company_tel || '',
              company_address: selectedCompany.company_address || '',
              recipient_company_no: newEmailInfo.recipient_company_no || '',
              recipient_place_no: newEmailInfo.recipient_place_no || ''
            };
            await updateCompany(selectedCompany.id, companyBody, queryParams);
          }
        }

        const updateData = {
          receiver_email: newEmailInfo.email,
          receiver_name: newEmailInfo.name,
          company_name: newEmailInfo.company,
          place_no: place_ID,
          company_no: people_ID,
          receiver_company_id: finalCompanyId
        };

        await updateEmail(selectedEmail.id, updateData);

        await fetchServerEmails();
        await fetchCompanyList(false);

        setNewEmailInfo({
          email: '',
          name: '',
          company: '',
          recipient_company_no: '',
          recipient_place_no: '',
          receiver_company_id: ''
        });
        setIsEditingEmail(false);
        setSelectedEmail(null);

        toast({
          title: "更新成功",
          description: "郵件資料已更新",
          status: "success",
          duration: 2000,
          isClosable: true,
        });
      } catch (error) {
        toast({
          title: "更新失敗",
          description: "無法更新郵件資料，請稍後再試",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      } finally {
        setIsLoadingEmails(false);
      }
    } else {
      handleAddFrequentEmail();
    }
  };
  const filteredCompanies = React.useMemo(() => {
    if (!companies || !Array.isArray(companies)) return [];

    const searchTerm = searchCompany.toLowerCase();
    return companies.filter(company => {
      return (
        (company.company_name && company.company_name.toLowerCase().includes(searchTerm)) ||
        (company.company_tel && company.company_tel.toLowerCase().includes(searchTerm)) ||
        (company.company_address && company.company_address.toLowerCase().includes(searchTerm))
      );
    });
  }, [companies, searchCompany]);

  const handleEditCompany = async (companyId) => {
    setIsLoadingCompany(true);
    try {
      const response = await getCompanyDetail(companyId);
      setSelectedCompany(response);
      setNewCompanyInfo({
        company_name: response.company_name || '',
        company_tel: response.company_tel || '',
        company_address: response.company_address || ''
      });
      setIsEditingCompany(true);
      setShowCompanyForm(true);
    } catch (error) {
      toast({
        title: "獲取公司詳情失敗",
        description: "請稍後再試",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsLoadingCompany(false);
    }
  };

  const handleSaveCompany = async () => {
    if (!newCompanyInfo.company_name) {
      toast({
        title: "訊息不完整",
        description: "請填寫公司名稱",
        status: "warning",
        duration: 2000,
        isClosable: true,
      });
      return;
    }

    if (!place_ID || !people_ID) {
      toast({
        title: "用戶訊息不完整",
        description: "無法識別當前用戶訊息，請重新登入",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    if (!newCompanyInfo.company_address) {
      toast({
        title: "訊息不完整",
        description: "請填寫公司地址",
        status: "warning",
        duration: 2000,
        isClosable: true,
      });
      return;
    }

    setIsLoadingCompany(true);
    try {
      const queryParams = {
        place_no: place_ID,
        company_no: people_ID
      };

      const bodyData = {
        company_name: newCompanyInfo.company_name,
        company_tel: newCompanyInfo.company_tel || '',
        company_address: newCompanyInfo.company_address
      };

      if (isEditingCompany && selectedCompany) {
        await updateCompany(selectedCompany.id, bodyData, queryParams);
        toast({
          title: "更新成功",
          description: "公司資料已更新",
          status: "success",
          duration: 2000,
          isClosable: true,
        });
      } else {
        await createCompany(bodyData, queryParams);
        toast({
          title: "新增成功",
          description: "已新增公司資料",
          status: "success",
          duration: 2000,
          isClosable: true,
        });
      }

      await fetchCompanyList();

      setShowCompanyForm(false);
      setIsEditingCompany(false);
      setSelectedCompany(null);
      setNewCompanyInfo({
        company_name: '',
        company_tel: '',
        company_address: ''
      });

    } catch (error) {
      toast({
        title: "保存失敗",
        description: "無法保存公司資料，請稍後再試",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsLoadingCompany(false);
    }
  };

  const handleDeleteCompany = async (companyId, e) => {
    if (e) e.stopPropagation();
    setShowDeleteCompanyConfirm(companyId);
  };

  const confirmDeleteCompany = async (companyId) => {
    setIsLoadingCompany(true);
    try {
      await deleteCompany(companyId);
      await fetchCompanyList();

      toast({
        title: "刪除成功",
        description: "公司資料已刪除",
        status: "success",
        duration: 2000,
        isClosable: true,
      });
    } catch (error) {
      toast({
        title: "刪除失敗",
        description: "無法刪除公司資料，請稍後再試",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsLoadingCompany(false);
      setShowDeleteCompanyConfirm(null);
    }
  };

  const handleNewCompanyInfoChange = (field, value) => {
    setNewCompanyInfo({
      ...newCompanyInfo,
      [field]: value,
    });
  };

  const handleSendMail = async () => {
    try {
      setEmailError('');
      const emailRegex = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/;

      const invalidEmails = emails.filter(
        (email) => !emailRegex.test(email.email) || email.email.trim() === ''
      );
      if (invalidEmails.length > 0) {
        setEmailError('Email格式不符,請重新確認');
        return;
      }

      const incompleteFields = emails.filter(
        (item) => !item.name.trim() || !item.company.trim() || !item.recipient_company_no?.trim() || !item.recipient_place_no?.trim()
      );
      if (incompleteFields.length > 0) {
        toast({
          title: "訊息不完整",
          description: "請為每位收件人提供姓名、公司名稱、運作人與場所管編",
          status: "warning",
          duration: 3000,
          isClosable: true,
        });
        return;
      }

      const share_link = shareInfo?.shareLink || JSON.parse(sessionStorage.getItem('pendingShareInfo'))?.shareLink;
      if (!share_link) {
        toast({
          title: "無法發送郵件",
          description: "尚未建立分享連結，請重新產生連結後再試",
          status: "error",
          duration: 4000,
          isClosable: true,
        });
        return;
      }

      const recipientEmails = emails.map(e => e.email);
      const recipientNames = emails.map(e => e.name);
      const recipientCompanies = emails.map(e => e.company);
      const sharePasswords = emails.map(() => password || '');
      const includePasswordsList = emails.map(e => e.includePassword);
      const peopleID = String(people_ID || '');
      const placeID = place_ID || '';
      const certNamesList = [certName || ''];
      const recipientCompanyNos = emails.map(e => e.recipient_company_no || '');
      const recipientPlaceNos = emails.map(e => e.recipient_place_no || '');
      const recipientPlaceNames = emails.map(() => '');

      await sendMail(
        share_link,
        recipientEmails,
        recipientNames,
        recipientCompanies,
        sharePasswords,
        includePasswordsList,
        peopleID,
        placeID,
        certNamesList,
        recipientCompanyNos,
        recipientPlaceNos,
        recipientPlaceNames
      );

      if (people_ID && place_ID) {
        const queryParams = {
          place_no: place_ID,
          company_no: people_ID
        };

        const addPromises = emails.map(async (email) => {
          try {
            const isFrequent = isEmailInFrequentList(
              email.email,
              frequentEmails,
              serverFrequentEmails
            );
            if (!isFrequent) {
              const result = await addRecipientToFrequent(
                {
                  email: email.email,
                  name: email.name,
                  company: email.company,
                  recipient_company_no: email.recipient_company_no || '',
                  recipient_place_no: email.recipient_place_no || ''
                },
                companies,
                createCompany,
                createEmail,
                queryParams,
                getCompanyList
              );
              return {
                email: email.email,
                success: result.success,
                companyId: result.newCompanyId
              };
            }
            return { email: email.email, success: true, wasAlreadyFrequent: true };
          } catch (error) {
            console.error(`Error adding ${email.email} to frequent list:`, error);
            return { email: email.email, success: false, error };
          }
        });

        const results = await Promise.allSettled(addPromises);

        const failureDetails = results
          .filter(r => r.status === 'rejected' || (r.status === 'fulfilled' && !r.value.success && !r.value.wasAlreadyFrequent))
          .map(r => {
            if (r.status === 'rejected') {
              return { email: 'unknown', reason: r.reason?.message || 'Promise rejected' };
            }
            return { email: r.value?.email || 'unknown', reason: r.value?.error || 'Unknown error' };
          });

        const failures = failureDetails.map(f => f.email);

        if (failures.length > 0) {
          console.warn("Failed to add some recipients to frequent list:", failureDetails);

          toast({
            title: "部分收件人添加失敗",
            description: `郵件已發送成功，但無法將 ${failures.join(", ")} 添加至常用收件人列表。將在下次嘗試添加。`,
            status: "warning",
            duration: 5000,
            isClosable: true,
          });

          setTimeout(() => {
            fetchServerEmails();
            fetchCompanyList(false);
          }, 1000);
        } else {
          toast({
            title: "已添加新收件人",
            description: "收件人已成功添加至常用收件人列表",
            status: "success",
            duration: 3000,
            isClosable: true,
          });
        }

        await fetchServerEmails();
        await fetchCompanyList(false);
      }

      const pendingShareInfo = JSON.parse(sessionStorage.getItem('pendingShareInfo'));
      if (pendingShareInfo) {
        setShareInfo(pendingShareInfo);
        sessionStorage.removeItem('pendingShareInfo');
      }

      setShowModel2(false);
      setShowFrequentEmails(false);

      toast({
        title: "郵件發送成功",
        description: "現在您可以複製分享連結了",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      toast({
        title: "郵件發送失敗",
        description: "請稍後再試或聯繫管理員",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const handleCancelMail = () => {
    const pendingShareInfo = JSON.parse(sessionStorage.getItem('pendingShareInfo'));
    if (pendingShareInfo) {
      cancelShareLink(id).catch(console.error);
      sessionStorage.removeItem('pendingShareInfo');
    }

    setEmails([{ email: '', name: '', company: '', includePassword: true }]);
    setShowModel2(false);
    setShowFrequentEmails(false);
    setShowCompanyList(false);
    setEmailError('');
    setShowModel(false);
    setPassword('');
  };

  const NoSetPassword = () => {
    return new Promise((resolve) => {
      setPassword("");
      resolve();
    })
      .then(() => {
        getShareLink(id, "")
          .then((res) => {
            var token = res.token;
            var date = dayjs();

            const linkInfo = {
              shared: true,
              shareDate: date.format('YYYY/MM/DD'),
              shareLink:
                window.location.origin +
                '/share/' +
                certName +
                '/' +
                token +
                '/' +
                date.format('YYYY-MM-DD'),
            };

            sessionStorage.setItem('pendingShareInfo', JSON.stringify(linkInfo));

            setShowModel(false);

            setShowModel2(true);
          })
          .catch(() => {
            toast({
              title: "錯誤",
              description: "登入時間到期，無法分享，請重新登入後再嘗試一次",
              status: "error",
              duration: 3000,
              isClosable: true,
            });
          });
      })
      .catch((error) => {
        console.error('Error in NoSetPassword:', error);
      });
  };

  const YesSetPassword = async () => {
    if (!password || password.length < 8 || password.length > 20) {
      toast({
        title: "密碼不符合要求",
        description: "請輸入8到20碼英文或數字",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    try {
      const res = await getShareLink(id, password);
      var token = res.token;
      var date = dayjs();

      const linkInfo = {
        shared: true,
        shareDate: date.format('YYYY/MM/DD'),
        shareLink:
          window.location.origin +
          '/share/' +
          certName +
          '/' +
          token +
          '/' +
          date.format('YYYY-MM-DD'),
      };

      sessionStorage.setItem('pendingShareInfo', JSON.stringify(linkInfo));

      setShowModel(false);

      setShowModel2(true);
    } catch (error) {
      toast({
        title: "錯誤",
        description: "登入時間到期，無法分享，請重新登入後再嘗試一次",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const closeShare = () => {
    cancelShareLink(id).then(() => {
      setShareInfo({ shared: false, shareDate: '', shareLink: '' });
      setPassword('');
      setEmails([{ email: '', name: '', company: '', includePassword: true }]);
    }).catch(error => {
      console.error('Error cancelling share link:', error);
    });

    setShareInfo({ shared: false, shareDate: '', shareLink: '' });
    setPassword('');
  };

  const copyShareLink = () => {
    toastIdRef.current = toast({
      description: '證書連結已複製',
      duration: 2000,
    });
    navigator.clipboard.writeText(shareInfo.shareLink);
  };


  return (
    <Stack h="100%" w="100%">
      {showModel3 && (
        <BlockchainViewerModal
          visible={showModel3}
          tx_block_number={tx_block_number}
          tx_paction_no={tx_paction_no}
          tx_place_no={tx_place_no}
          tx_company_no={tx_company_no}
          tx_block_hash={tx_block_hash}
          tx_TransactionHash={tx_TransactionHash}
          tx_raw_data={tx_raw_data}
          onClose={() => setShowModel3(false)}
        />
      )}

      {showModel2 && (
        <div className="model-overlay">
          <div
            className="model"
            style={{
              width: showFrequentEmails || showCompanyList ? '650px' : '500px',
              maxWidth: '90vw',
              maxHeight: '90vh',
              overflowY: 'auto',
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            {showCompanyList ? (
              <CompanyManagerModal
                visible={true}
                companies={filteredCompanies}
                searchText={searchCompany}
                onSearchChange={setSearchCompany}
                onAddCompany={() => {
                  setShowCompanyForm(true);
                  setIsEditingCompany(false);
                  setNewCompanyInfo({
                    company_name: '',
                    company_tel: '',
                    company_address: ''
                  });
                }}
                onEditCompany={handleEditCompany}
                onDeleteCompany={handleDeleteCompany}
                onClose={() => {
                  setShowCompanyList(false);
                  setShowFrequentEmails(true);
                  setNewEmailInfo({ email: '', name: '', company: '' });
                }}
              />
            ) : showFrequentEmails ? (
              <>
                <EmailManagerModal
                  visible={true}
                  frequentEmails={filteredFrequentEmails}
                  searchText={searchFrequentEmail}
                  onSearchChange={setSearchFrequentEmail}
                  isLoading={isLoadingEmails}
                  newEmailInfo={newEmailInfo}
                  onNewEmailChange={handleNewEmailInfoChange}
                  companies={companies}
                  onShowCompanyList={fetchCompanyList}
                  onSelectEmail={handleSelectFrequentEmail}
                  onEditEmail={handleEditEmail}
                  onDeleteEmail={handleDeleteFrequentEmail}
                  onAddEmail={handleSaveEmail}
                  isEditingEmail={isEditingEmail}
                  onClose={() => {
                    setShowFrequentEmails(false);
                    setNewEmailInfo({ email: '', name: '', company: '' });
                    setIsEditingEmail(false);
                  }}
                />
              </>
            ) : (
              <SendEmailModal
                visible={true}
                emails={emails}
                emailError={emailError}
                onEmailChange={handleEmailChange}
                onAddEmail={addEmailField}
                onRemoveEmail={removeEmailField}
                onShowFrequentEmails={() => setShowFrequentEmails(true)}
                onCancel={handleCancelMail}
                onSend={handleSendMail}
              />
            )}
          </div>
        </div>
      )}

      {showModel && (
        <PasswordModal
          visible={showModel}
          password={password}
          onPasswordChange={setPassword}
          onSetPassword={YesSetPassword}
          onSkipPassword={NoSetPassword}
          onCancel={handleClosePasswordModal}
        />
      )}
      {showConfirmDelete && (
        <ConfirmDeleteModal
          visible={true}
          title="確定要刪除此常用信箱嗎？"
          isLoading={isLoadingEmails}
          onConfirm={() => confirmDelete(showConfirmDelete)}
          onCancel={cancelDelete}
        />
      )}
      {showDeleteCompanyConfirm && (
        <ConfirmDeleteModal
          visible={true}
          title="確定要刪除此公司資料嗎？此操作無法復原。"
          isLoading={isLoadingCompany}
          onConfirm={() => confirmDeleteCompany(showDeleteCompanyConfirm)}
          onCancel={() => setShowDeleteCompanyConfirm(null)}
        />
      )}
      {showCompanyForm && (
        <CompanyFormModal
          visible={true}
          isEditing={isEditingCompany}
          companyInfo={newCompanyInfo}
          isLoading={isLoadingCompany}
          onInfoChange={handleNewCompanyInfoChange}
          onSubmit={handleSaveCompany}
          onCancel={() => setShowCompanyForm(false)}
        />
      )}

      <ContentHeader title="毒化物證書" />

      <TabsContainer
        tabIndex={tabIndex}
        setTabIndex={setTabIndex}
        shareInfo={shareInfo}
        password={password}
        url={url}
        area={area}
        people_ID={people_ID}
        place_ID={place_ID}
        certName={certName}
        tx={tx}
        onPasswordUpdate={() => passwordUpdate(id, password)}
        onCopyShareLink={copyShareLink}
        onShowSendEmail={() => setShowModel2(true)}
        onCancelShare={closeShare}
        onEnableSharing={() => setShowModel(true)}
        onViewTransaction={(txHash) => {
          handleLinkClick(txHash);
          setShowModel3(true);
        }}
      />

      <Footer />
    </Stack>
  );
}

export default withAuth(Cert);
